export default {
  prefix: '',
  thousands: '',
  decimal: '.',
  precision: 2
}



// WEBPACK FOOTER //
// ./src/lib/v-money/options.js